module.exports = __webpack_public_path__ + "static/media/AmaniHeaderLogo.7aa7fc77.png";